<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <v-form class="multi-col-validation mt-6">
        <v-row>
          <v-col
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="account.name"
              label="Name"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="account.email"
              label="E-mail"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="account.level_user"
              dense
              label="Role"
              outlined
              :items="['Admin','Product','Operational','Accounting']"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="account.phone"
              dense
              outlined
              label="Phone"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="account.password"
              type="password"
              dense
              outlined
              label="Password"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="account.password_confirmation"
              type="password"
              dense
              outlined
              label="Repeat Password"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              @click="SaveAccount()"
            >
              <span v-if="!account.id_user">Save New Account</span>
              <span v-else>Update Account</span>
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              type="reset"
              @click.prevent="resetForm"
            >
              Cancel
            </v-btn>
          </v-col>
        </v-row>
      </v-form>

      <v-divider class="mt-4"></v-divider>

      <template>
        <v-card>
          <v-card-title>
            Data User
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="users"
            :search="search"
          >
            <template #[`item.actions`]="{ item }">
              <v-btn
                small
                class="mr-2 text-capitalize primary"
                @click="editItem(item)"
              >
                <v-icon>{{ icons.mdiPencil }}</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios'
import { mdiAlertOutline, mdiCloudUploadOutline, mdiPencil } from '@mdi/js'

export default {
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Name User',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Role', value: 'level_user' },
        { text: 'Email', value: 'email' },
        { text: 'Phone', value: 'phone' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
        mdiPencil,
      },
      account: {
        id_user: '',
        name: '',
        level_user: '',
        email: '',
        phone: '',
        password: '',
        password_confirmation: '',
      },
      users: [],
    }
  },
  mounted() {
    this.DataUser()
  },
  methods: {
    editItem(item) {
      this.account = item
    },
    DataUser() {
      this.$root.$emit('PesanLoading', 'Proses Login')
      axios.get('auth/user/DataUser').then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.users = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    resetForm() {
      this.account = {
        id_user: '',
        name: '',
        level_user: '',
        email: '',
        phone: '',
        password: '',
        password_confirmation: '',
      }
    },
    SaveAccount() {
      this.$root.$emit('PesanLoading', 'Proses Login')
      axios.post('auth/user/SaveAccount', this.account).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.resetForm()
        this.DataUser()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
